import { render, staticRenderFns } from "./AdminFrequentQuestionForm.vue?vue&type=template&id=4368947e&"
import script from "./AdminFrequentQuestionForm.vue?vue&type=script&lang=js&"
export * from "./AdminFrequentQuestionForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports